import { change } from "redux-form";
import FormConstants from "./DataEntryFieldsConstants";

/**
 * Writes a single field's value into a redux-form instance via redux-form's
 * own `change()` action creator (mirrors the `resetFieldValue` pattern already
 * used in DataEntryDetailsRightPane.tsx - NOT the raw `@@redux-form/CHANGE`
 * dispatch hack used by that file's local `changeFieldValue` helper).
 *
 * Shared by both the classic RightPane Details tab and the Quick Entry
 * field-group row so both views read/write the same DATA_ENTRY_FIELDS_FORM
 * state (Spec #34098 / F1a, AC11, Business Rule 14).
 *
 * Never logs `value` - it may be PHI-adjacent form data (see
 * .claude/rules/hipaa-compliance.md).
 */
export function writeFieldToForm(
    dispatch: Function,
    fieldName: string,
    value: any,
    formName: string = FormConstants.DATA_ENTRY_FIELDS_FORM,
): void {
    dispatch(change(formName, fieldName, value));
}

export default writeFieldToForm;
